import * as React from 'react';

export const IconReplace = (props: React.SVGProps<SVGSVGElement>) => (
	<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
		<path
			fillOpacity={0.5}
			strokeWidth={0.5}
			stroke="currentColor"
			d="M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z"
		/>
		<path d="M0 0h24v24H0z" fill="none" />
	</svg>
);
